<template>
  <div id="otp-entry">
    <br class="clearField">
    <br class="clearField">
    <input v-for="digit in digits" class="otp-digit" :id="'otp-' + digit" type="number"
           pattern="[0-9]*" min="0" max="9" maxlength="1" value="" inputmode="numeric"
           @keyup="fillDigits">
    <br>
    <input type="button" :value="strings['SubmitOtp']" id="verify-button"
           class="button button-primary button-large" @click="checkOTP">
  </div>
</template>

<script setup>
import $ from "jquery";
import {ref} from "vue";

const emit = defineEmits(['otpAccepted', 'otpRejected']);
const props = defineProps(["strings"]);
const strings = props['strings'];
let otp = ref('');
const digits = [1, 2, 3, 4, 5, 6];

function fillDigits(e) {
  let el = e.target;
  let key = e.keyCode;

  // do nothing if Shift, Tab, CMD, Option, Control
  const ignoredKeys = [16, 9, 224, 18, 17];
  if (ignoredKeys.indexOf(key) !== -1) {
    return;
  }

  // on Backspace or Left Arrow, go to the previous field
  if ((key === 8 || key === 37) && el.previousElementSibling && el.previousElementSibling.className === "otp-digit") {
    el.previousElementSibling.focus();
  } else if (key !== 8 && el.nextElementSibling && el.nextElementSibling.className === "otp-digit") {
    el.nextElementSibling.focus();
  }

  // if more than one digit is entered into an input, split across next inputs
  if (el.value.length > 1) {
    let data = e.data || e.target.value;
    if (!data) return;
    if (data.length === 1) return;
    fillNext(e.target, data);
  }
}

// populates the next element with next digit of data
function fillNext(el, data) {
  el.value = data[0]; // apply first digit to first input
  data = data.substring(1);
  if (el.nextElementSibling && el.nextElementSibling.className === "otp-digit" && data.length) {
    el.nextElementSibling.select();
    // rinse and repeat with next element
    fillNext(el.nextElementSibling, data);
  }
}

function checkOTP() {
  $(document.body).css({'cursor' : 'wait'});
  $('#send-button').prop("disabled", true);

  otp.value = getOtpFromFields();
  $.post(strings['AjaxUrl'], {
    action: 'check-otp',
    usernameOrEmail: $('#user_login').val(),
    OTP: otp.value
  }, function(res) {
    if (res === "1") {
      emit('otpAccepted', otp.value, 'message');
    } else {
      emit('otpRejected');
    }

    $(document.body).css({'cursor' : 'default'});
  });
}

function getOtpFromFields() {
  return $('#otp-1').val() + $('#otp-2').val() + $('#otp-3').val() + $('#otp-4').val()
      + $('#otp-5').val() + $('#otp-6').val();
}
</script>

<style scoped>
#otp-entry {
  text-align: center;
  font-size: 20px;
}

.otp-digit {
  width: 22px;
  height: 40px !important;
  margin: 2px 2px 10px 2px;
}

#verify-button{
  float: none;
}

/* hide up/down arrows: */
/* Chrome, Safari, Edge, Opera */
.otp-digit::-webkit-outer-spin-button,
.otp-digit::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.otp-digit {
  -moz-appearance: textfield;
}
</style>